import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import { getTrackingPayload } from 'src/lib/trackingPayload';
import type { BackendMutationSendTrackingParamsArgs, BackendUser } from 'src/types/backend';

const MUTATION = gql`
  mutation SendTrackingParams($trackingPayload: JSON!, $source: String!) {
    sendTrackingParams(trackingPayload: $trackingPayload, source: $source) {
      id
    }
  }
`;

type Variables = Pick<BackendMutationSendTrackingParamsArgs, 'source'>;
type Result = Pick<BackendUser, 'id'>;

export const sendTrackingParams = async ({ source }: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables: {
      trackingPayload: JSON.stringify(getTrackingPayload() || {}),
      source,
    },
  });
  return getSingleProp<Result>(result.data);
};
